import {
  BlackboardFormat,
  BlackboardFrame,
} from "interfaces/models/blackboard";
import { InstanceProperty } from "interfaces/models/inspectionInstance";
import { InspectionItemResult } from "interfaces/models/inspectionItemResult";
import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useReducer,
} from "react";
import {
  initialPreviewBlackboardState,
  PreviewBlackboardReducer,
  PreviewBlackboardActions,
  PreviewBlackboardState,
} from "./reducer";

type Props = PropsWithChildren<{
  itemResults?: InspectionItemResult[];
  blackboardFormat?: BlackboardFormat;
  blackboardFrames?: BlackboardFrame[];
  isLoadingPropertyInstance?: boolean;
  mapInstanceProperty?: Map<string, InstanceProperty> | undefined;
}>;

const PreviewBlackboardContext = createContext<any>({
  ...initialPreviewBlackboardState,
});

const PreviewBlackboardDispatchContext = createContext(
  (() => {}) as React.Dispatch<PreviewBlackboardActions>
);

// Define the provider component
export function PreviewBlackboardProvider({
  children,
  itemResults,
  blackboardFormat,
  blackboardFrames,
  isLoadingPropertyInstance,
  mapInstanceProperty,
}: Props) {
  // @ts-ignore
  const [state, dispatch] = useReducer(PreviewBlackboardReducer, {
    ...initialPreviewBlackboardState,
  });

  const value = useMemo(() => {
    return {
      ...state,
      ...{ ...(itemResults && { itemResults }) },
      ...{ ...(blackboardFormat && { blackboardFormat }) },
      ...{ ...(blackboardFrames && { blackboardFrames }) },
      ...{
        ...(isLoadingPropertyInstance !== undefined && {
          isLoadingPropertyInstance,
        }),
      },
      ...{ ...(mapInstanceProperty && { mapInstanceProperty }) },
    };
  }, [
    state,
    itemResults,
    blackboardFormat,
    blackboardFrames,
    isLoadingPropertyInstance,
    mapInstanceProperty,
  ]);

  return (
    <PreviewBlackboardContext.Provider value={value}>
      <PreviewBlackboardDispatchContext.Provider value={dispatch}>
        {children}
      </PreviewBlackboardDispatchContext.Provider>
    </PreviewBlackboardContext.Provider>
  );
}

export function useContextPreviewBlackboard() {
  return useContext(PreviewBlackboardContext) as PreviewBlackboardState;
}

export function usePreviewBlackboardDispatch() {
  return useContext(PreviewBlackboardDispatchContext);
}
